import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '@/views/List/index.vue'
import Contract from '@/views/Contract/index.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: List
  },
  {
    path: '/contract/:address?',
    name: 'Contract',
    component: Contract,
  },

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('ROUTER MIDDLEWARE', store.state.account);
  // if (to.name !== 'Home' && !isAuthenticated) next({ name: 'Login' })
  // else next()
  next();
})

export default router
